// extracted by mini-css-extract-plugin
export default {"wrapper":"Kp-z","response":"Lp-z","error":"Mp-z","disabled":"Np-z","buttons":"Op-z","feedbackQuestionSection":"Pp-z","yesNoWrapper":"Qp-z"};